import templateUrl from "emun.salesrep/manager-dashboard.htm";
import dashboardQuickReportFilters from "emun.salesrep/quick-report-filters.htm";
import salesAnalysisURL from "emun.salesrep/sales-analysis-prompt.htm";
import salesrepConfig from "emun.salesrep/salesrep.config";
import basicController from "servicestack/basic.controller.properties";
import $appConfig from "servicestack/config";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";

class ManagerDashboardController {
  constructor(createAutoQuery, $session, $window, $state) {
    basicController(this);
    var map = this;
    let $ctrl = this;
    console.info("$ctrl", $ctrl);
    console.info("this.repId", this.repId, $ctrl.repId);
    $ctrl.salesrepConfig = salesrepConfig;
    $ctrl.chartLoaded = false;
    this.productImage = $appConfig.productImage.bind($appConfig);
    let options = {
      url: "QuerySalesReps.json?IncludeSalesData=true&Id=" + this.repId,
      pageSize: 15,
      orderBy: "Name",
      autoLoad: true,
      append: false,
      onLoaded: function (args) {
        $ctrl.rep = args.first;
        $ctrl.$state.current.customTitle = $ctrl.rep.name;
      },
    };
    $ctrl.goals = {
      month: 0,
      monthPercent: 0,
      quarter: 0,
      quarterPercent: 0,
      year: 0,
      yearPercent: 0,
    };
    this.dailySales = {
      total: 0,
      count: 0,
    };
    this.yesterdaySales = {
      total: 0,
      count: 0,
    };
    this.weekSales = {
      total: 0,
      count: 0,
    };
    this.lastweekSales = {
      total: 0,
      count: 0,
    };
    this.quarterSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    this.lastquarterSales = {
      total: 0,
      count: 0,
    };
    this.ytdSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    this.lastytdSales = {
      total: 0,
      count: 0,
    };
    this.mtdSales = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    this.lastmtdSales = {
      total: 0,
      count: 0,
    };

    $ctrl.dailyInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.yesterdayInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.weekInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.lastweekInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.quarterInvoice = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastquarterInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.ytdInvoice = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastytdInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.mtdInvoice = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastmtdInvoice = {
      total: 0,
      count: 0,
    };

    this.query = createAutoQuery(options);

    $ctrl.quickReportsQuery = createAutoQuery({
      url: "QueryQuickReports.json?",
      orderBy: "Type,Name",
      sortOptions: {
        "Type,Name": "Name: A to Z",
        "-Type,Name": "Name: Z to A",
      },
      tagCriteria: {
        Dashboards: "Manager",
      },
      autoLoad: true,
      onLoaded(args) {
        $ctrl.quickReports = args.results;
      },
      pageSize: 1000,
    });

    $ctrl.dailySalesQuery = createAutoQuery({
      url:
        "QuerySalesYOYTotals.json?Sum=TotalSalesToday,TotalSalesCountToday,TotalSalesYesterday,TotalSalesCountYesterday,TotalSalesWeekToDate,TotalSalesCountWeekToDate,TotalSalesQuarterToDate,TotalSalesCountQuarterToDate,TotalSalesQuarterToDateLastYear,TotalSalesCountQuarterToDateLastYear,TotalSalesYearToDate,TotalSalesCountYearToDate,TotalSalesYearToDateLastYear,TotalSalesCountYearToDateLastYear,TotalSalesMonthToDate,TotalSalesCountMonthToDate,TotalSalesMonthToDateLastYear,TotalSalesCountMonthToDateLastYear&GroupBy=SalesRepID&managerId=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.dailySales.total += res.sumTotalSalesToday;
            $ctrl.dailySales.count += res.sumTotalSalesCountToday;
            $ctrl.yesterdaySales.total += res.sumTotalSalesYesterday;
            $ctrl.yesterdaySales.count += res.sumTotalSalesCountYesterday;
            $ctrl.weekSales.total += res.sumTotalSalesWeekToDate;
            $ctrl.weekSales.count += res.sumTotalSalesCountWeekToDate;
            $ctrl.quarterSales.total += res.sumTotalSalesQuarterToDate;
            $ctrl.quarterSales.count += res.sumTotalSalesCountQuarterToDate;
            $ctrl.lastquarterSales.total +=
              res.sumTotalSalesQuarterToDateLastYear;
            $ctrl.lastquarterSales.count +=
              res.sumTotalSalesCountQuarterToDateLastYear;
            var percent = Math.round(
              ($ctrl.quarterSales.total / $ctrl.lastquarterSales.total) * 100
            );
            if (percent < 100) {
              $ctrl.quarterSales.percent = 100 - percent;
              $ctrl.quarterSales.trend = "down";
            } else if (percent > 100) {
              $ctrl.quarterSales.percent = percent - 100;
              $ctrl.quarterSales.trend = "up";
            } else {
              $ctrl.quarterSales.percent = 100;
              $ctrl.quarterSales.trend = "neutral";
            }
            $ctrl.ytdSales.total += res.sumTotalSalesYearToDate;
            $ctrl.ytdSales.count += res.sumTotalSalesCountYearToDate;
            $ctrl.lastytdSales.total += res.sumTotalSalesYearToDateLastYear;
            $ctrl.lastytdSales.count +=
              res.sumTotalSalesCountYearToDateLastYear;
            percent = Math.round(
              ($ctrl.ytdSales.total / $ctrl.lastytdSales.total) * 100
            );
            if (percent < 100) {
              $ctrl.ytdSales.percent = 100 - percent;
              $ctrl.ytdSales.trend = "down";
            } else if (percent > 100) {
              $ctrl.ytdSales.percent = percent - 100;
              $ctrl.ytdSales.trend = "up";
            } else {
              $ctrl.ytdSales.percent = 100;
              $ctrl.ytdSales.trend = "neutral";
            }
            $ctrl.mtdSales.total += res.sumTotalSalesMonthToDate;
            $ctrl.mtdSales.count += res.sumTotalSalesCountMonthToDate;
            $ctrl.lastmtdSales.total += res.sumTotalSalesMonthToDateLastYear;
            $ctrl.lastmtdSales.count +=
              res.sumTotalSalesCountMonthToDateLastYear;
            percent = Math.round(
              ($ctrl.mtdSales.total / $ctrl.lastmtdSales.total) * 100
            );
            if (percent < 100) {
              $ctrl.mtdSales.percent = 100 - percent;
              $ctrl.mtdSales.trend = "down";
            } else if (percent > 100) {
              $ctrl.mtdSales.percent = percent - 100;
              $ctrl.mtdSales.trend = "up";
            } else {
              $ctrl.mtdSales.percent = 100;
              $ctrl.mtdSales.trend = "neutral";
            }
          });
        }
      },
    });

    $ctrl.dailyInvoiceQuery = createAutoQuery({
      url:
        "QueryInvoiceYOYTotals.json?Sum=TotalInvoiceToday,TotalInvoiceCountToday,TotalInvoiceYesterday,TotalInvoiceCountYesterday,TotalInvoiceWeekToDate,TotalInvoiceCountWeekToDate,TotalInvoiceQuarterToDate,TotalInvoiceCountQuarterToDate,TotalInvoiceQuarterToDateLastYear,TotalInvoiceCountQuarterToDateLastYear,TotalInvoiceYearToDate,TotalInvoiceCountYearToDate,TotalInvoiceYearToDateLastYear,TotalInvoiceCountYearToDateLastYear,TotalInvoiceMonthToDate,TotalInvoiceCountMonthToDate,TotalInvoiceMonthToDateLastYear,TotalInvoiceCountMonthToDateLastYear&GroupBy=SalesRepID&managerId=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.dailyInvoice.total += res.sumTotalInvoiceToday;
            $ctrl.dailyInvoice.count += res.sumTotalInvoiceCountToday;
            $ctrl.yesterdayInvoice.total += res.sumTotalInvoiceYesterday;
            $ctrl.yesterdayInvoice.count += res.sumTotalInvoiceCountYesterday;
            $ctrl.weekInvoice.total += res.sumTotalInvoiceWeekToDate;
            $ctrl.weekInvoice.count += res.sumTotalInvoiceCountWeekToDate;
            $ctrl.quarterInvoice.total += res.sumTotalInvoiceQuarterToDate;
            $ctrl.quarterInvoice.count += res.sumTotalInvoiceCountQuarterToDate;
            $ctrl.lastquarterInvoice.total +=
              res.sumTotalInvoiceQuarterToDateLastYear;
            $ctrl.lastquarterInvoice.count +=
              res.sumTotalInvoiceCountQuarterToDateLastYear;
            var percent = Math.round(
              ($ctrl.quarterInvoice.total / $ctrl.lastquarterInvoice.total) *
                100
            );
            if ($ctrl.lastquarterInvoice.total === 0) {
              percent = 100;
            }
            if (percent < 100) {
              $ctrl.quarterInvoice.percent = 100 - percent;
              $ctrl.quarterInvoice.trend = "down";
            } else if (percent > 100) {
              $ctrl.quarterInvoice.percent = percent - 100;
              $ctrl.quarterInvoice.trend = "up";
            } else {
              $ctrl.quarterInvoice.percent = 100;
              $ctrl.quarterInvoice.trend = "neutral";
            }
            $ctrl.ytdInvoice.total += res.sumTotalInvoiceYearToDate;
            $ctrl.ytdInvoice.count += res.sumTotalInvoiceCountYearToDate;
            $ctrl.lastytdInvoice.total += res.sumTotalInvoiceYearToDateLastYear;
            $ctrl.lastytdInvoice.count +=
              res.sumTotalInvoiceCountYearToDateLastYear;
            percent = Math.round(
              ($ctrl.ytdInvoice.total / $ctrl.lastytdInvoice.total) * 100
            );
            if ($ctrl.lastytdInvoice.total === 0) {
              percent = 100;
            }
            if (percent < 100) {
              $ctrl.ytdInvoice.percent = 100 - percent;
              $ctrl.ytdInvoice.trend = "down";
            } else if (percent > 100) {
              $ctrl.ytdInvoice.percent = percent - 100;
              $ctrl.ytdInvoice.trend = "up";
            } else {
              $ctrl.ytdInvoice.percent = 100;
              $ctrl.ytdInvoice.trend = "neutral";
            }
            $ctrl.mtdInvoice.total += res.sumTotalInvoiceMonthToDate;
            $ctrl.mtdInvoice.count += res.sumTotalInvoiceCountMonthToDate;
            $ctrl.lastmtdInvoice.total +=
              res.sumTotalInvoiceMonthToDateLastYear;
            $ctrl.lastmtdInvoice.count +=
              res.sumTotalInvoiceCountMonthToDateLastYear;
            percent = Math.round(
              ($ctrl.mtdSales.total / $ctrl.lastmtdSales.total) * 100
            );
            if ($ctrl.lastmtdInvoice.total === 0) {
              percent = 100;
            }
            if (percent < 100) {
              $ctrl.mtdInvoice.percent = 100 - percent;
              $ctrl.mtdInvoice.trend = "down";
            } else if (percent > 100) {
              $ctrl.mtdInvoice.percent = percent - 100;
              $ctrl.mtdInvoice.trend = "up";
            } else {
              $ctrl.mtdInvoice.percent = 100;
              $ctrl.mtdInvoice.trend = "neutral";
            }
          });
        }
      },
    });

    $ctrl.lastweekSalesQuery = createAutoQuery({
      url:
        "QuerySalesDailyTotals.json?dateRange=LastWeek&Sum=OrderTotal&Count=OrderTotal&GroupBy=SalesRepID&managerId=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.lastweekSales.total += Math.round(res.sumOrderTotal);
            $ctrl.lastweekSales.count += res.countOrderTotal;
          });
        }
      },
    });
    $ctrl.goalsQuery = createAutoQuery({
      url:
        "QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth,SalesGoalThisQuarter&GroupBy=vendorID&managerId=" +
        $ctrl.repId,
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.goals.month += Math.round(res.sumSalesGoalThisMonth);
            $ctrl.goals.quarter += Math.round(res.sumSalesGoalThisQuarter);
            $ctrl.goals.year += Math.round(res.sumSalesGoalThisYear);
          });

          $ctrl.goals.monthPercent = Math.round(
            ($ctrl.mtdSales.total / $ctrl.goals.month) * 100
          );
          $ctrl.goals.quarterPercent = Math.round(
            ($ctrl.quarterSales.total / $ctrl.goals.quarter) * 100
          );
          $ctrl.goals.yearPercent = Math.round(
            ($ctrl.ytdSales.total / $ctrl.goals.year) * 100
          );
        }
      },
    });

    $ctrl.backlogTotal = 0;
    $ctrl.allocatedTotal = 0;
    $ctrl.pendingTotal = 0;
    $ctrl.pendingCount = 0;
    
		$ctrl.backlogSalesQuery = createAutoQuery({
			url: 'QuerySalesDailyCustomerVendorTotals.json?Sum=Backlog,Allocated&GroupBy=vendorID&managerId=' + $ctrl.repId,
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				if (args.total > 0) {
					args.results.forEach(function (res) {
						$ctrl.backlogTotal += Math.round(res.sumBacklog);
						$ctrl.allocatedTotal += Math.round(res.sumAllocated);
					});
				}
			}
		});
    $ctrl.pendingOrdersQuery = createAutoQuery({
      url:
        "QueryCartItemsJoin.json?Sum=ExtendedTotal&CountDistinct=CartId&ClientVersionNotEqualTo=%20&Exported=1&Status=Open&GroupBy=SalesRepId&ManagerId=" +
        $ctrl.repId,
      pageSize: 1000,
      autoLoad: true,
      onLoaded: function(totals) {
        $ctrl.chartLabels = [];
        $ctrl.chartData = [];
        totals.results.forEach(function(total) {
          $ctrl.pendingTotal += total.sumExtendedTotal || 0;
          $ctrl.pendingCount += total.countDistinctCartId || 0;
        });
      }
    });


    this.$session = $session;
    $ctrl.markets = [];
    $ctrl.showCodesQuery = createAutoQuery({
      url: "QueryMarketDates.json",
      autoLoad: true,
      take: 1000,
      onLoaded: function (args) {
        args.results.forEach(function (market) {
          if (
            $ctrl.markets.filter(
              (m) => m.market === market.market && m.year === market.year
            ).length === 0
          ) {
            $ctrl.markets.push(market);
          }
        });
      },
    });
  }
  load() {
    return this.query.load.apply(this.query, arguments);
  }

  runSalesAnalysisReport() {
    let $ctrl1 = this;
    return modals.open({
      templateUrl: salesAnalysisURL,
      controllerAs: "$ctrl",
      controller($scope, $uibModalInstance, $session) {
        let $ctrl = this;
        $ctrl.startOn = moment().subtract(1, "days");
        $ctrl.repId = "";
        //$ctrl.endOn = moment().subtract(1, 'days');
        $ctrl.dismiss = $ctrl.cancel = function () {
          $uibModalInstance.close();
        };
        $ctrl.runReport = function () {
          $uibModalInstance.close();
          //console.info("ctrl", $ctrl);
          let url = $appConfig.resolveServiceUrl(
            "RunSalesAnalysis?startDate=" +
              $ctrl.startOn.format("MM/DD/YYYY") +
              "&repId=" +
              $ctrl.request.SalesRep.id
          );
          return (location.href = url);
        };
      },
      size: "lg",
    }).result;
  }

  runReportWithOptions(name, displayName) {
    let $ctrl1 = this;
    $ctrl1.bus = new ServiceBus();
    //console.log("run with options", name);
    return modals.open({
      templateUrl: dashboardQuickReportFilters,
      controllerAs: "$ctrl",
      controller($scope, $uibModalInstance, $session) {
        let $ctrl = this;
        var monthNum = moment().month();
        $ctrl.month = moment().month(monthNum).format("MM");
        $ctrl.startOn = moment();

        $ctrl1.bus
          .send("QuerySalesRepList.json?Active=1&OrderBy=Name")
          .then(function (res) {
            $ctrl.reps = res.data.results;
          });
        $ctrl.showReps = true;
        $ctrl.dismiss = $ctrl.cancel = function () {
          $uibModalInstance.close();
        };
        $ctrl.runReport = function () {
          //$uibModalInstance.close();
          var queryString = "";
          if ($ctrl.repId != undefined) {
            queryString = "&repIdOverride=" + $ctrl.repId.id;
          } else if ($ctrl1.rep != undefined && $ctrl1.rep.regionId) {
            queryString += "&region=" + $ctrl1.rep.regionId;
          }
          if ($ctrl.region != undefined) {
          }

          if ($ctrl.dateType != undefined) {
            queryString += "&dateType=" + $ctrl.dateType;
          }
          //$ctrl.startOn = $ctrl.month + "/15/" + moment().year();
          //$ctrl.startOn = $ctrl.startOn.format('MM-DD-YYYY');
          var startOn = $ctrl.startOn.format("MM-DD-YYYY");
          let url = $appConfig.resolveServiceUrl(
            "RunReport?reportName=" +
              name +
              "&displayName=" +
              displayName +
              "&output=xlsx&startDate=" +
              startOn +
              "&timeZoneOffset=" +
              moment().utcOffset() +
              queryString
          );
          //console.debug("URL", url, $ctrl1.rep);
          return (location.href = url);
        };
      },
      size: "lg",
    }).result;
  }

  runReport(name) {
    const $ctrl = this;
    let url = $appConfig.resolveServiceUrl(
      "" + name + "?ManagerId=" + $ctrl.repId
    );
    return (location.href = url);
  }

  exportQuickReport(report) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        report.name +
        " &output=xlsx&QuickReportID=" +
        report.id +
        "&@RepId=" +
        $ctrl.repId +
        "&QuickReportName=" +
        report.name
    );

    return (location.href = url);
  }
}
export default {
  bindings: {
    repId: "@",
  },
  require: {
    container: "^managerContainer",
  },
  controller: ManagerDashboardController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
